import { lazy } from "react";

const routes = [
  {
    path: "/category",
    element: lazy(() => import("../pages/Category")),
  },
  {
    path: "/category/add",
    element: lazy(() => import("../pages/Category/create-update")),
  },
  {
    path: "/category/add/:id",
    element: lazy(() => import("../pages/Category/create-update")),
  },
];

export default routes;
